const strings = {
  admin: {
    columns: {
      users: "Users",
      devices: "Devices",
    },
    modal: {
      nameLabel: "Name",
      namePlaceholder: "Enter name",
      invalidName: "Invalid name",

      emailLabel: "Email",
      emailPlaceholder: "Enter email address",
      invalidEmail: "Invalid email address",
      addAccountDescription:
        "Add a new account by entering the account name and email address below. The user will receive an email invitation to join the account and will be designated admin, allowing them to invite/delete users.",
      addAccount: "Add Account",
    },
    removeAccount: "Remove Account",
    addAccount: "ADD NEW ACCOUNT",
  },
};

export default strings;
